import React from 'react'
import styled from 'styled-components'

import IconThumbUpBlue from '../../assets/icons/thumb-up-blue.svg'

const ChiSiamoStyle = styled.div`
  .socialLink {
    display: grid;
    grid-template-columns: 28px 1fr;
    grid-gap: 10px;
    align-items: center;
    margin: 20px 0;

    h5 {
      font-size: 1.1em;
      font-weight: 500;
      color: #0B33F8;
    }
  }
`;

export default class ChiSiamo extends React.Component {
  render() {
    return (
      <ChiSiamoStyle>
        <p>La Proloco di Ozzero nasce il 1 aprile 2008 grazie a un gruppo di volontari uniti dal medesimo desiderio di arricchire, appassionare e aggregare la comunità ozzerese.<br/>L'Associazione è un centro permanente di vita associativa a carattere volontario, democratico e apolitico la cui attività è espressione di partecipazione e pluralismo.<br/> Non ha alcun fine di lucro ed opera per l'esclusivo soddisfacimento di interessi collettivi. <br/> Nel corso degli anni ha svolto un lavoro costante per valorizzare, tutelare e promuovere il patrimonio storico, culturale e ambientale di Ozzero e dei suoi dintorni.<br/> La Pro Loco grazie all’organizzazione di manifestazioni culturali, folkloristiche e sportive, di spettacoli pubblici, convegni e rappresentazioni, coinvolge i cittadini di Ozzero e non solo, nella gioviale tradizione di accoglienza della campagna lombarda.</p>
        <a href="https://www.facebook.com/Organizzazione.no.profit.Ozzero/" target="_blank" rel="noopener noreferrer">
          <div className="socialLink">
            <img src={IconThumbUpBlue} alt="Thumb Up Icon" style={{height: '28px', cursor: 'pointer'}}/>
            <h5>Pagina Facebook</h5>
          </div>
        </a>
      </ChiSiamoStyle>
    )
  }
}